module.exports = __webpack_public_path__ + "img/title-left2.1d8a615.png";